document.addEventListener("DOMContentLoaded", () => {
    const initializeImageViewer = (viewer) => {
        if (!viewer) return;


        const imageViewer = document.querySelector('.image-viewer')

        const animation = imageViewer.dataset.animation;

        if(animation !== '1') return;

        const imageGridTop = viewer.querySelector('.image-grid-top');
        const imageGridBottom = viewer.querySelector('.image-grid-bottom');
        
        if (!imageGridTop || !imageGridBottom) return;

        let ticking = false;
        let isInView = false;

        // Adjust these to control speed while maintaining coverage
        // Lower values = less movement = safer coverage
        const speedTop = 0.008; // Slightly reduced for safety
        const speedBottom = 0.008;
        
        const viewportHeight = window.innerHeight;
        
        // Calculate max possible translation to ensure coverage
        // With 120vw width and -10vw position, we have 20vw total buffer
        // So max translation should stay within ±10vw
        const MAX_TRANSLATION = 15; // vw units

        const updateAnimation = () => {
            if (!isInView) {
                ticking = false;
                return;
            }

            const rect = viewer.getBoundingClientRect();
            
            // Progress: 0 when block enters at bottom, increases as it moves up
            const progress = Math.max(0, viewportHeight - rect.top);
            
            // Limit translation to stay within coverage buffer
            let translateXValueTop = (progress * speedTop);
            let translateXValueBottom = (progress * speedBottom);
            
            // Clamp values to prevent revealing edges
            translateXValueTop = Math.min(translateXValueTop, MAX_TRANSLATION);
            translateXValueBottom = Math.min(translateXValueBottom, MAX_TRANSLATION);

            imageGridTop.style.transform = `translateX(${translateXValueTop}vw)`;
            imageGridBottom.style.transform = `translateX(-${translateXValueBottom}vw)`;

            ticking = false;
        };

        const handleScroll = () => {
            if (!ticking) {
                requestAnimationFrame(updateAnimation);
                ticking = true;
            }
        };

        const observerOptions = {
            root: null,
            rootMargin: '0px 0px -11% 0px', // Start slightly earlier
            threshold: 0
        };

        const observerCallback = (entries) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    isInView = true;
                    window.addEventListener('scroll', handleScroll, { passive: true });
                    updateAnimation();
                } else {
                    isInView = false;
                    window.removeEventListener('scroll', handleScroll);
                }
            });
        };

        const observer = new IntersectionObserver(observerCallback, observerOptions);
        observer.observe(viewer);
    };

    document.querySelectorAll(".image-viewer").forEach(initializeImageViewer);
});